var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('main-menu',{attrs:{"opciones-menu":_vm.opcionesMenu}}),_c('router-view'),_c('main-footer',{attrs:{"opciones-menu":_vm.opcionesMenu,"redes-sociales":_vm.redesSociales}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }